import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import 'moment-duration-format';
import { ConfigConstants } from '../../config/config-constants';

@Pipe({
    name: 'formatDuration',
    standalone: false,
})
export class FormatDurationPipe implements PipeTransform {
    public transform(duration: number, timeSheetEntry = false): string {
        const modifiedDuration = moment.duration(duration, 'hours');
        if (modifiedDuration.asMinutes() < 0) {
            return '';
        }
        if (timeSheetEntry) {
            // For the timesheet screen, decided to keep the same format as in the crm-time-recording screen.
            // Where duration is displayed as "1h 30m"
            return Math.floor(modifiedDuration.asHours()) + 'h ' + modifiedDuration.minutes() + 'm';
        } else {
            // If Duration is less than one hour, lets say 56 Minutes then moment.duration returns duration as "56" instead of 00:56
            // moment.utc does not work if duration is more than 24 hours, so using moment utc, only if it is less than 1 hours
            if (duration < 1) {
                return moment.utc(modifiedDuration.asMilliseconds()).format('HH:mm');
            }
            return modifiedDuration.format(ConfigConstants.formatPatternTimeGeneric);
        }
    }
}
